<template>
  <div>
    <van-cell-group>
      <van-cell title="我的打卡" is-link @click="goToDaka" />
    </van-cell-group>
  </div>
</template>

<script>
export default {
  name: 'Person',
  methods: {
    goToDaka () {
      this.$router.push('/PatientPadDakaPage')
    }
  }
}
</script>

<style scoped>

</style>
